export default {
    install: (app, options) => {
        app.config.globalProperties.$saveCacheData = $saveCacheData;
        app.config.globalProperties.$retrieveCacheData = $retrieveCacheData;
        app.config.globalProperties.$deleteCacheData = $deleteCacheData;
        app.provide('CacheUtil', options);
    }
}


export function $saveCacheData(cacheName,cacheData){
    
    if(cacheName&&cacheData){
        if (typeof Storage !== "undefined") {     
            sessionStorage.setItem(cacheName,JSON.stringify(cacheData));       
        }else{
            alert("Your browser doesn't support functinalities required for this application.");            
        }
    }
    
    
}

export function $retrieveCacheData(cacheName){
    
    if(cacheName){
        if (typeof Storage !== "undefined") {     
            let data=sessionStorage.getItem(cacheName);
            if(data){
                return JSON.parse(data);
            }            
        }else{
            alert("Your browser doesn't support functinalities required for this application.");            
        }
    }
    return null;
    
}

export function $deleteCacheData(cacheName){
    
    if(cacheName){
        if (typeof Storage !== "undefined") {     
            sessionStorage.removeItem(cacheName);                       
        }else{
            alert("Your browser doesn't support functinalities required for this application.");            
        }
    }
}